import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { COMMON_AGENT_FILTER_SEARCH_PARAMS } from "../../../agent/api";
import { DEFAULT_DEBT_ACCOUNTS_REPORT_QUERY_PARAMS } from "../api";
import { DebtAccountsReportFilterForm } from "../components/forms/DebtAccountsReportFilterForm";
import { DebtAccountsReportTable } from "../components/tables/DebtAccountsReportTable";
import { DebtAccountsReportFilterPageRequest } from "../types";

export const DebtAccountsReportContainer = () => {
  const searchParams = useFilterSearchParams<DebtAccountsReportFilterPageRequest>({
    params: [
      "balanceAsOfDate",
      "categories",
      ...COMMON_AGENT_FILTER_SEARCH_PARAMS,
      "includeZeroBalance",
      "includeUnprocessed",
    ],
    defaultQueryParamsObject: DEFAULT_DEBT_ACCOUNTS_REPORT_QUERY_PARAMS,
  });

  return (
    <ContentWrapper>
      <DebtAccountsReportFilterForm searchParams={searchParams} />

      <DebtAccountsReportTable searchParams={searchParams} />
    </ContentWrapper>
  );
};
